/****************************************************
 * Module Name:  kapanCreationMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Tooltip, Typography } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../../common/dataGridCellExpand";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import KapanCreationProxy from "../../../utility/proxy/manager/manufacturingProxy/kapanCreationProxy";
import Select from "react-select";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddPackageDetail from "../../manufactureMaster/addPackageDetail";
import AddPackage from "../../manufactureMaster/addPackage";
import { LoadingButton } from "@mui/lab";
import { GiPowderBag } from 'react-icons/gi'
import NoPermission from "../../common/noPermission";
import KapanCreationDetailModal from "./kapanCreationDetailModal";
import AddKapan from "./addKapan";
import { RiRedPacketFill } from "react-icons/ri";
import PacketProxy from "../../../utility/proxy/manager/manufacturingProxy/packetProxy";
import KapanHistoryModal from "./kapanHistoryModal";
import PageTitle from "../../common/pageTitle";

const fullOptionToValue = (selectedData, optionArr) => {
  if (selectedData.value === "*")
    return Utility.GetValueArrayWithoutStar(optionArr);

  return Utility.GetValueArrayWithStarReplace(
    selectedData,
    Utility.GetValueArrayWithoutStar(optionArr)
  );
};

export class KapanCreationMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      kapanCreations: [],
      combinedFilterValues: {},
      showAddKapanModal: false,
      accesDenied: false,
      kapanCreationId: "",
      kapanCreationname: "",
      modalData: {},
      showDetailModal: false,
      editOperation: false,
      sourceData: {},
      totalKapanPcs: 0,
      kapanCarats: 0,
      showPackageModal: false,
      packageloadingButton: false,
      loadingButton: false,
      packetloadingButton: false,
      showPackageDetailModal: false,
      packageDetailloadingButton: false,
      kapanid: "",
      showKapanDetailModal: false,
      totalPacketCount: "",
      isKapanStatusNew: "",
      snackbarVariant: "",
      snackbarMessage: "",
      showSnackbar: "",
      kapanppc: "",
      totalKapan: 0,
      totalPrice: 0,
      totalCarats: 0,
      avgPrice: 0,
      columnNames: [],
      statusOption: [
        { label: 'ANY', value: '*' },
        { label: 'NEW', value: 'NEW' },
        { label: 'PACKAGE_INPROGRESS', value: 'PACKAGE_INPROGRESS' },
        { label: 'PACKAGED', value: 'PACKAGED' }
      ],
      status: [{ label: 'NEW', value: 'NEW' },],

      showKapanCreationLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_OPERATION_KAPANCREATION
      ),
      packaging_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_PACKAGING
      ),
    };
    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("MANUFACTURING_OPERATION_KAPANCREATION");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetch();
    }
  }


  fetch = () => {
    this.fetchKapanCreationData(false, [{ label: 'NEW', value: 'NEW' }]);
  }

  fetchKapanCreationData = (bAnimateSpinner, lstatus) => {
    let status = fullOptionToValue(lstatus, this.state.statusOption);
    bAnimateSpinner && this.setState({ showKapanCreationLoadSpinner: true });
    KapanCreationProxy.GetAllKapanCreationByStatus(status, (responseData) => {
      if (responseData) {
        const uniqueFilterValues = {
          user: Utility.getDistinctOptions(responseData, "username"),
          department: Utility.getDistinctOptions(responseData, "department_name"),
        };

        const combinedFilterValues = {
          user: uniqueFilterValues.user.map(value => {
            const matchingItem = responseData.find(item => item.username === value);
            return matchingItem ? `${matchingItem.userid} | ${value}` : value;
          }),
          department: uniqueFilterValues.department.map(value => {
            const matchingItem = responseData.find(item => item.department_name === value);
            return matchingItem ? `${matchingItem.department_id} | ${value}` : value;
          }),
          status: this.state.statusOption.filter(option => option.value !== "ANY"),

        };

        this.setState({
          kapanCreations: responseData,
          combinedFilterValues: combinedFilterValues,
          showKapanCreationLoadSpinner: false,
        })
        this.getSummaryReport(responseData);

        this.prepareColumns(combinedFilterValues);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          showKapanCreationLoadSpinner: false,
        })
      }
    });
  };

  getSummaryReport = (data) => {
    if (!Array.isArray(data)) return;
    let totalKapans = data.length;
    let carats = 0;
    let price = 0;
    data.forEach((item) => {
      carats += item.carats;
      price += item.carats * item.price;
    });
    let avgprice = price / carats;

    this.setState({
      totalKapan: totalKapans,
      totalPrice: price,
      totalCarats: carats,
      avgPrice: avgprice
    });
  }

  setSnackbarState = (show, message, variant) => {
    this.setState({
      showSnackbar: show,
      snackbarMessage: message,
      snackbarVariant: variant,
    })
  }

  closePackaging = (kapanid) => {
    this.setState({ showKapanCreationLoadSpinner: true });
    //Creating new issue, and once issue is created on call refresh the list of current issue
    KapanCreationProxy.CloseKapanPackaging(kapanid, (response) => {
      if (response) {
        this.fetchKapanCreationData(true, this.state.status);
        this.setState({ showKapanCreationLoadSpinner: false });
        this.setSnackbarState(true, response.errorMessage, response.status);
      } else {
        this.setState({ showKapanCreationLoadSpinner: false });
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
      }
    });
  }

  handleKapanDetailModal = (params) => {
    this.setState({ kapanid: params, showKapanDetailModal: true });
  };

  prepareColumns = (uniqueFilterValues) => {

    const columnNames = this.columnsWithoutPermission.map(woPermissionColumn => {
      let guids = [];

      // Determine which GUIDs (permissions) should be added based on the column field

      switch (woPermissionColumn.field) {
        case "status":
          guids = [
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PCS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CARATS,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_PRICE,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_CREATEDAT,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_USER,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_DEPARTMENT,
            Constants.COLUMN_PERMISSION.MFG_KAPAN_CRTN_FROM_LOTS
          ];
          break;
        default:
          guids = [];
      }

      // Retrieve valid permission columns
      return this.fetchColumnDataFromGuid(guids, woPermissionColumn, this.columnsWithPermission, uniqueFilterValues);

    }).flat(); // Flatten the array

    // Update state with the prepared columns
    this.setState({
      columnNames: columnNames
    })
  };

  fetchColumnDataFromGuid = (guids, currentColumn, columnsWithPermission, uniqueFilterValues) => {

    const permissionColumns = guids
      .map(id => Constants.USER_COLUMN_PERMISSION.find(permission => permission === id)) // Match permissions
      .filter(Boolean) // Remove undefined values (invalid permissions)
      .map(guid => {
        const columnData = columnsWithPermission[guid]; // Get column details

        // If the columnData is missing or an empty object, skip adding it
        if (!columnData || Object.keys(columnData).length === 0) {
          return null;
        }

        // Retrieve unique filter values for the column, defaulting to an empty array
        const filterData = uniqueFilterValues[columnData.field] || [];

        return {
          ...columnData,  // Copy all existing column properties
          valueOptions: filterData,  // Assign filter values
        };
      })
      .filter(Boolean); // Remove any null values from the list

    // Modify the original column before adding it to the list
    const modifiedColumn = {
      ...currentColumn,  // Retain original column properties
      valueOptions: uniqueFilterValues[currentColumn.field] || [], // Assign filter values
    };

    // Return an array with the modified column and any valid permission columns
    return [modifiedColumn, ...permissionColumns];
  };

  columnsWithPermission = {
    "01b85657-9c59-4cda-9c3c-05ea1fd72c7d": {
      field: "pcs",
      headerName: "PCS",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
      flex: 0.5,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value,
    },
    "eebb216a-fc07-4240-984c-55abad8655f8": {
      field: "carats",
      headerName: "CTS",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
      flex: 0.5,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "8a5f7bcf-0623-4bcc-a449-24ab91c75997": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand
    },
    "f277d253-9fb9-4c5f-9f2f-3e13fb44b1cf": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.value),
    },
    "87705e55-c76c-46a4-a15b-da129da04e36": {
      field: "user",
      headerName: "USER",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      type: "singleSelect",
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => params.row.userid + " | " + params.row.username,
      renderCell: renderCellExpand
    },
    "291073dc-bce6-4b03-9204-9c887e5db384": {
      field: "department",
      headerName: "DEPARTMENT",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      type: "singleSelect",
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => params.row.department_id + " | " + params.row.department_name,
      renderCell: renderCellExpand
    },
    "6adbfb63-dd08-40df-9aba-7751a8018e13": {
      field: "lots",
      headerName: "FROM LOT ID/CTS",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ minHeight: "auto", mt: 1 }}>
          {params.value.map((item, index) => (
            <Chip
              key={index}
              avatar={<Avatar>{item.lotcreationid}</Avatar>}
              label={item.carats}
              sx={{ margin: "0px 10px 10px 0px" }}
            />
          ))}
        </Box>
      ),
      disableExport: true,
    },
  };

  columnsWithoutPermission = [
    {
      field: "id",
      headerName: "KAPANID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black',
          }}
          onClick={() => this.handleKapanDetailModal(params.value)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      field: "package",
      headerName: "PACKETS",
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const { row } = params;
        const isKapanStatusNew = row.status === "NEW";
        const handleUpdatePackage = (e) => {
          e.stopPropagation();
          this.setState({ isKapanStatusNew, kapanid: row.id, kapanppc: row.price, totalKapanPcs: row.pcs, kapanCarats: row.carats });
          this.getpacketsDetail(row.id);
        };

        const handleCreatePackage = (e) => {
          e.stopPropagation();
          this.setState({
            showPackageModal: true,
            editOperation: false,
            sourceData: row,
            packageloadingButton: false,
            isKapanStatusNew,
            kapanppc: row.price,
            totalKapanPcs: row.pcs,
            kapanCarats: row.carats,
          });
        };

        if (row.status === "PACKAGE_INPROGRESS" && Utility.isUpdateAllowed(this.state.packaging_Permission)) {
          return (
            <Button
              startIcon={<GiPowderBag />}
              sx={{ width: 200 }}
              color="success"
              variant="contained"
              onClick={handleUpdatePackage}
            >
              Update Package
            </Button>
          );
        }

        if (row.status === "NEW" && Utility.isAddAllowed(this.state.packaging_Permission)) {
          return (
            <Button
              startIcon={<RiRedPacketFill />}
              sx={{ width: 200 }}
              variant="contained"
              onClick={handleCreatePackage}
            >
              Create Package
            </Button>
          );
        }

        return "-";
      },
      disableExport: true,
    },
    {
      field: "stoppackage",
      headerName: "CLOSE PACKAGING",
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const { row } = params;
        if (row.status === "PACKAGE_INPROGRESS" && (Utility.isUpdateAllowed(this.state.packaging_Permission) || Utility.isAddAllowed(this.state.packaging_Permission))) {
          return (
            <Button
              startIcon={<GiPowderBag />}
              sx={{ width: 200 }}
              color="error"
              variant="contained"
              onClick={() => this.closePackaging(row.id)}
            >
              Close Packaging
            </Button>
          );
        }
        return "-";
      },
      disableExport: true,
    },
  ];

  hideModal = () => {
    this.setState({
      showAddKapanModal: false,
      showPackageDetailModal: false,
      showPackageModal: false
    });
  };

  getpacketsDetail = (id) => {
    this.setState({ packetloadingButton: true });
    KapanCreationProxy.GetMyKapanDetail(id, false, (response) => {
      if (response) {
        this.setState({ showPackageDetailModal: true, showDetailModal: false, packetloadingButton: false, sourceData: response });
      } else {

        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({
          packetloadingButton: false,
        });
      }
    })
  }

  handleValidation = (kapanCreationData) => {
    //TODO do validation if needed here
    return true;
  };

  addKapan = (kapanCreationData) => {
    this.setState({ loadingButton: true });
    //Creating new KapanCreation, and once kapanCreation is created on call refresh the list of current kapanCreations
    KapanCreationProxy.AddKapanCreation(kapanCreationData, (response) => {
      if (response) {
        this.fetchKapanCreationData(true, this.state.status);
        this.setState({ loadingButton: false, showAddKapanModal: false });
        this.setSnackbarState(true, response.errorMessage, response.status);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({ loadingButton: false, showAddKapanModal: false });
      }
    });
  };

  addPackage = (packageData) => {
    this.setState({ packageloadingButton: true });
    if (packageData && packageData.totalpackets) {

      this.setState({
        kapanid: packageData.kapanid,
        totalPacketCount: packageData.totalpackets,
        showPackageModal: false,
        packageloadingButton: false,
        showPackageDetailModal: true,
      });
    } else {
      this.setState({
        errorSnackbar: true,
        errorMessage: Constants.APiFailErrorMessage,
        snackbarVariant: "error",
        packageloadingButton: false,
      });
    }

  };

  AddPackageDetail = (packageData) => {
    this.setState({ packageDetailloadingButton: true });
    //Creating new issue, and once issue is created on call refresh the list of current issue
    PacketProxy.AddPackets(packageData, this.state.kapanid, (response) => {
      if (response) {
        this.fetchKapanCreationData(true, this.state.status);
        this.setState({ packageDetailloadingButton: false, showPackageDetailModal: false });
        this.setSnackbarState(true, response.errorMessage, response.status);
      } else {
        this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
        this.setState({ packageDetailloadingButton: false, showPackageDetailModal: false });
      }
    });
  };

  handleRowClick = (params) => {
    let data = params.row;
    this.setState({
      modalData: {
        lotid: data.id,
        createdat: data.createdat,
        lots: data.lots,
        username: data.username,
      },
      showDetailModal: true,
    });
  };

  handleClose = () => {
    this.setState({ showDetailModal: false });
  };

  render() {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }

    const rows = this.state.kapanCreations;

    const columns = (Utility.isAddAllowed(this.state.packaging_Permission) || Utility.isUpdateAllowed(this.state.packaging_Permission))
      ? this.state.columnNames
      : this.state.columnNames.filter(
        (col) => col.field !== "package"
      );
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showSnackbar}
          message={this.state.snackbarMessage}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          title={this.state.snackbarVariant === "success" ? "Success" :
            this.state.snackbarVariant === "error" ? "Failed" : "Warning"}
          handleClose={() => this.setState({ showSnackbar: false })}
        />
        {this.state.showKapanDetailModal ? (
          <KapanHistoryModal
            show={this.state.showKapanDetailModal}
            kapanId={this.state.kapanid}
            close={() => this.setState({ showKapanDetailModal: false })}
          />
        ) : null}

        {this.state.showAddKapanModal ? (
          <AddKapan
            show={true}
            handleClose={this.hideModal}
            handleSave={this.addKapan}
            handleValidation={this.handleValidation}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}

        {this.state.showPackageModal ? (
          <AddPackage
            Show={true}
            handleClose={this.hideModal}
            handleSave={this.addPackage}
            handleValidation={this.handleValidation}
            loading={this.state.packageloadingButton}
            sourceData={this.state.sourceData}
            kapanToPacket={true}
          />
        ) : (
          <Box />
        )}

        {this.state.showPackageDetailModal ? (
          <AddPackageDetail
            Show={true}
            handleClose={this.hideModal}
            handleSave={this.AddPackageDetail}
            handleValidation={this.handleValidation}
            loading={this.state.packageDetailloadingButton}
            sourceData={this.state.sourceData}
            fromKapan={true}
            kapanId={this.state.kapanid}
            isKapanStatusNew={this.state.isKapanStatusNew}
            isPacketStatusNew={null}
            fromPacketId={null}
            addPacketPermission={Utility.isAddAllowed(this.state.packaging_Permission)}
            totalPacketCount={this.state.totalPacketCount}
            kapanppc={this.state.kapanppc}
            kapanPcs={this.state.totalKapanPcs}
            maxCarats={this.state.kapanCarats}
          />
        ) : (
          <Box />
        )}

        <Box
          sx={{
            display: "flex",
            width: "35%",
            gap: "20px",
            margin: 2
          }}
        >
          <Box sx={{ alignSelf: "center", mt: 1 }}>
            <Typography>Status</Typography>
          </Box>
          <Box
            sx={{
              alignSelf: "center",
              minWidth: "60%",
              mt: 1,
            }}
          >
            <Select menuPlacement="auto"
              blurInputOnSelect={false}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              value={this.state.status}
              isSearchable={true}
              isMulti
              closeMenuOnSelect={false}
              name="Status"
              menuPortalTarget={document.body}
              styles={Constants.Styles}
              options={this.state.statusOption}
              onChange={(selectedOption) =>
                this.setState({
                  status: selectedOption,
                })
              }
            />
          </Box>
          <Box sx={{ mt: 1 }}>
            <LoadingButton
              variant="contained"
              loading={this.state.showKapanCreationLoadSpinner}
              loadingPosition="start"
              onClick={() => this.fetchKapanCreationData(false, this.state.status)}
              startIcon={<SearchOutlinedIcon size="large" />}
            >
              Search
            </LoadingButton>
          </Box>

        </Box>
        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: "600",
              },
              "& .css-cc8tf1": {
                fontWeight: "600",
              },
              height: "77vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: GridToolbar }}
              rows={rows}
              // onRowDoubleClick={this.handleRowClick}
              columns={columns}
              getRowId={(row) => row.id}
              loading={this.state.showKapanCreationLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    //  id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "11px",
                left: "590px",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '36rem',
                color: "black",
                fontWeight: 'normal',
                fontSize: Constants.defaultTableFontSize
              }}
            ><p style={{ margin: 0 }}>
                <span>Total Kapan:</span> <b>{this.state.totalKapan}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>Total Carats: </span> <b>{this.state.totalCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>Total Price: </span> <b>{this.state.totalPrice.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>Avg Price: </span> <b>{isNaN(this.state.avgPrice) ? "0.00" : this.state.avgPrice.toFixed(2)}</b></p>
            </Box>
            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
              {this.state.showKapanCreationLoadSpinner ? (
                <CircularProgress size="25px" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="medium"
                    onClick={() => this.fetchKapanCreationData(true, this.state.status)}
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
              {Utility.isAddAllowed(this.state.local_Permission) ? (
                <Tooltip title="Kapan Creation">
                  <Button
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ ml: "5px" }}
                    onClick={() =>
                      this.setState({
                        showAddKapanModal: true,
                        editOperation: false,
                        sourceData: {},
                        loadingButton: false,
                      })
                    }
                    startIcon={<AddBoxOutlinedIcon size="large" />}
                  >
                    Kapan Creation
                  </Button>
                </Tooltip>
              ) : null}
              {this.state.showDetailModal ? (
                <KapanCreationDetailModal
                  data={this.state.modalData}
                  handleClose={this.handleClose}
                />
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default KapanCreationMaster;
